// An account that never finished checkout has no subscription status at all (e.g. a sign-up that left the Stripe
// checkout page). Nothing used to tell it to subscribe: the payment banner only appears after a payment fails.
// needsBillingSetup() is true for exactly those accounts - never for free / comped / manual ones, canceled ones,
// demo accounts or company homes (which are created comped).

const NO_CHARGE_STATUSES = new Set(['comped', 'free', 'manual']);
const NO_CHARGE_MODES = new Set(['manual', 'comped', 'free', 'no_charge']);

const lower = (value) => String(value || '').trim().toLowerCase();

export function needsBillingSetup(subscription, organization) {
  const sub = subscription || {};
  if (!organization?.id) return false;
  if (lower(organization.type) === 'demo' || organization.id === 'org_001') return false;
  if (organization.homeOfCompanyId) return false;
  if (sub.comped === true || NO_CHARGE_STATUSES.has(lower(sub.status)) || NO_CHARGE_MODES.has(lower(sub.billingMode))) return false;
  return !lower(sub.status);
}

export const BILLING_SETUP_ROLES = ['owner', 'admin'];
